import { events } from 'aws-amplify/data';
import { updateEvents } from './slices/applicant-detail-slices/documents-slice';
import { updateExportEvents } from './slices/exports-slice';
import { addJob, receiveJobEvent } from './slices/jobs-slice';
import { graphqlApi } from './api';

const jobEvent = (key) => (data) => receiveJobEvent({ key, event: typeof data.event === 'string' ? JSON.parse(data.event) : data.event });

const documentFetchHandler = (getState) => (data) => (dispatch) => {
    let event = data?.event;
    if (typeof event === 'string') {
        try { event = JSON.parse(event); } catch { return; }
    }
    const receiptId = event?.receiptId;
    if (!receiptId) return;
    dispatch(updateEvents({ event }));
    const uuid = getState().documentsSlice?.pendingDownloadsByReceiptId?.[receiptId]?.uuid;
    if (uuid) dispatch(graphqlApi.endpoints.getDocumentStatus.initiate({ uuid }, { forceRefetch: true }));
};

const CHANNEL_CONFIGS = [
    { path: '/documents/fetch', handlerFactory: documentFetchHandler },
    { path: '/documents/export', action: updateExportEvents },
    { path: '/reports/recommendations-approved', action: jobEvent('recommendations') },
    { path: '/search/change-workflow-complete', action: jobEvent('changeWorkflow') },
    { path: '/search/override-workflow-decision-complete', action: jobEvent('overrideWorkflowDecision') },
    { path: '/reports/publish-complete', action: jobEvent('publish') },
    { path: '/reports/program-change-or-withdraw-complete', action: jobEvent('programChangeOrWithdrawal') },
];

const JOB_LABELS = {
    '/reports/recommendations-approved': () => 'Submitting approvals...',
    '/reports/publish-complete': () => 'Publishing applications...',
    '/reports/program-change-or-withdraw-complete': () => 'Processing program change or withdraw requests...',
    '/search/change-workflow-complete': () => 'Processing workflow changes...',
    '/search/override-workflow-decision-complete': () => 'Processing administrative overrides...',
};

const channelState = {};

export async function connectEventChannel(path, action, dispatch, getState) {
    if (process.env.REACT_APP_API_EVENTS_DISABLED === 'true') return;
    if (channelState[path]?.connected) return;
    if (channelState[path]?.connecting) return channelState[path].promise;

    let resolve;
    const promise = new Promise(r => { resolve = r; });
    channelState[path] = { connecting: true, connected: false, promise };
    try {
        console.debug(`[event-channel] connecting to ${path}...`);
        const channel = await events.connect(path);
        channelState[path] = { connecting: false, connected: true, channel };
        console.debug(`[event-channel] connected to ${path}`);
        channel.subscribe({
            next: (data) => {
                console.debug(`[event-channel] received on ${path}`, data);
                const result = action(data);
                if (typeof result === 'function') result(dispatch);
                else dispatch(result);
            },
            error: (err) => {
                console.error(`[event-channel] error on ${path}`, err);
                channelState[path] = { connecting: false, connected: false };
                setTimeout(() => connectEventChannel(path, action, dispatch, getState), 3000);
            },
        });
    } catch (err) {
        console.error(`[event-channel] failed to connect to ${path}`, err);
        channelState[path] = { connecting: false, connected: false };
        setTimeout(() => connectEventChannel(path, action, dispatch, getState), 3000);
    }
    resolve();
}



export const getOnQueryStarted = (reportPath) => {
    return async (variables, { dispatch, queryFulfilled }) => {
        await connectChannel(reportPath, dispatch);
        try {
            console.debug("reportPath in onQueryStarted:", reportPath);
            const label = JOB_LABELS[reportPath]?.(variables) ?? reportPath;
            const { data } = await queryFulfilled;
            dispatch(addJob({ id: data?.executionId, label }));
        } catch { 
            console.error(`Error starting job for ${reportPath}`); 
        }
    }
}

export const connectChannel = async (path, dispatch, getState) => {
    const config = CHANNEL_CONFIGS.find(c => c.path === path);
    if (!config) { console.warn(`[event-channel] no config found for path: ${path}`); return; }
    const action = config.handlerFactory ? config.handlerFactory(getState) : config.action;
    await connectEventChannel(config.path, action, dispatch, getState);
};

